/** API resource path for Nest `@Controller("employeeLeaveNotifyContacts")`. */
export const EMPLOYEE_LEAVE_NOTIFY_CONTACTS_LOCATION = "employeeLeaveNotifyContacts";

export type LeaveNotifyContactSource = "DIRECTORY" | "MANUAL";

export type LeaveNotifyContactRow = {
  id: string;
  employeeId: number;
  itsId: string | null;
  name: string;
  whatsappNumber: string;
  source: LeaveNotifyContactSource;
};

export type ManualLeaveNotifyContactFormValues = {
  name: string;
  itsId: string;
  whatsappNumber: string;
};

export const EMPTY_MANUAL_LEAVE_NOTIFY_CONTACT_FORM: ManualLeaveNotifyContactFormValues = {
  name: "",
  itsId: "",
  whatsappNumber: "",
};

const WHATSAPP_NUMBER_PATTERN = /^\+?[0-9]{7,15}$/;

export type LeaveNotifyContactCreatePayload = {
  employeeId: number;
  itsId?: string;
  name: string;
  whatsappNumber: string;
};

/** Validate the manual-entry mini-form. Returns an error message or a create payload. */
export function validateManualLeaveNotifyContactForm(
  employeeId: number,
  values: ManualLeaveNotifyContactFormValues
): { ok: true; payload: LeaveNotifyContactCreatePayload } | { ok: false; error: string } {
  if (!Number.isFinite(employeeId) || employeeId < 1) {
    return { ok: false, error: "Employee is required." };
  }

  const name = values.name.trim();
  if (!name) {
    return { ok: false, error: "Name is required." };
  }

  const whatsappNumber = values.whatsappNumber.trim();
  if (!WHATSAPP_NUMBER_PATTERN.test(whatsappNumber)) {
    return { ok: false, error: "Enter a valid WhatsApp number (7-15 digits, optional +)." };
  }

  const itsId = values.itsId.trim();
  return {
    ok: true,
    payload: {
      employeeId,
      name,
      whatsappNumber,
      ...(itsId ? { itsId } : {}),
    },
  };
}

/** Extract list rows from react-admin / Nest list responses. */
export function extractLeaveNotifyContactRows(data: unknown): LeaveNotifyContactRow[] {
  if (!data || typeof data !== "object") return [];
  const body = data as { rows?: unknown; data?: unknown };
  if (Array.isArray(body.rows)) return body.rows as LeaveNotifyContactRow[];
  if (Array.isArray(body.data)) return body.data as LeaveNotifyContactRow[];
  if (Array.isArray(data)) return data as LeaveNotifyContactRow[];
  return [];
}
